module.exports = __webpack_public_path__ + "img/profile-color.febd67d2.png";